




















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteConveniosStore from '@/components/Suporte/Store/SuporteConveniosStore'
import _ from 'lodash'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteConvenios extends Vue {
  loadFornecedores: boolean = false
  loadConvenio: string = ''

  get getSuporteConveniosStore() {
    return getModule(SuporteConveniosStore, this.$store)
  }

  get paginationConvenio() { return this.getSuporteConveniosStore.paginationConvenio }

  get loadingConvenio() { return this.loadConvenio }
  set loadingConvenio(value: string) { this.loadConvenio = value }

  get hospitalId() { return this.getSuporteConveniosStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteConveniosStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get convenioHeaders() {
    return [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
      { text: 'Particular', value: 'particular', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get convenios() { return this.getSuporteConveniosStore.convenios }
  get searchConvenio() { return this.getSuporteConveniosStore.searchConvenio }
  set searchConvenio(value: string) { this.getSuporteConveniosStore.setSearchConvenio(value) }

  async hospitalChange(id: any) {
    this.getSuporteConveniosStore.clearConvenio()
    this.getSuporteConveniosStore.setHospitalId(id)

    const params: any = { hospitalId: id }

    await this.getSuporteConveniosStore.getConvenios()
  }

  adicionaConvenio() {
    this.getSuporteConveniosStore.setMode({ modal: 'procedimento', mode: 'CREATE' })
    this.getSuporteConveniosStore.setModal({ name: 'convenio', value: true })
  }

  async editarConvenio(item: any) {
    this.loadingConvenio = item.id
    await this.getSuporteConveniosStore.getConvenioById(item.id)
    await this.getSuporteConveniosStore.getAllConvenioPlanoByConvenio()
    this.getSuporteConveniosStore.setMode({ mode: 'EDIT' })
    this.getSuporteConveniosStore.setModal({ name: 'convenio', value: true })
    this.loadingConvenio = ''
  }

  beforeDestroy() {
    this.getSuporteConveniosStore.clearConvenioPlano()
    this.getSuporteConveniosStore.clearHospitalId()
  }
}
